import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid, Button } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { Filter, Main } from '../../containers';

import { getTeachersAction } from '../teacherrolls/state/actions';
import { getServedItems } from '../sitesetup/state/servedItems/actions';
import {
  getHistoryByItemReportAction,
  getHistoryByItemReportExcel,
  getHistoryByStudentReportAction,
  getHistoryByStudentReportExcel,
  getHistoryByDateReportAction,
  getHistoryByDateReportExcel,
  clearReportDataAction,
  getUsersAction,
} from './state/actions';

import TransactionHistoryForm from './components/TransactionHistoryForm';
import TransactionHistoryByStudentForm from './components/TransactionHistoryByStudentForm';
import TransactionHistoryByDateForm from './components/TransactionHistoryByDateForm';
import { ReportGeneration } from 'Common/ObjectHelper';
import { ReportFieldEnum, FieldEnum } from 'Common/FieldEnum';
import moment from 'moment';
import { getAccountSetup } from '../accountsetup/state/actions';
import { createToast, toastType } from 'Common/ToastHelper';
import { TransactionType, FormNameByTransactionType } from './constants';

import 'PageStyles/transactionhistory/index.less';
import { reportFormatEnum } from 'Common/Constants/Enumeration/ReportFormatEnum';

class TransactionHistoryContainer extends Component {
  state = {
    transactionType: TransactionType.Item,
    inProgress: true,
    reportFormat: reportFormatEnum.PDF,
  };

  componentDidMount() {
    this.props.getServedItems();
    this.props.getUsersAction();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.recordFetching &&
      nextProps.report &&
      nextProps.report !== this.props.report
    ) {
      if (nextProps.report.length !== 0) {
        const { report } = nextProps;
        ReportGeneration(report, 'TransactionHistoryByItemReport');
        this.props.clearReportDataAction();
      }
    }
    if (
      this.props.recordFetching &&
      nextProps.studentReport &&
      nextProps.studentReport !== this.props.studentReport
    ) {
      if (nextProps.studentReport.length !== 0) {
        const { studentReport } = nextProps;
        ReportGeneration(studentReport, 'TransactionHistoryByStudentReport');
        this.props.clearReportDataAction();
      }
    }
    if (
      this.props.recordFetching &&
      nextProps.dateReport &&
      this.state.inProgress &&
      nextProps.dateReport !== this.props.dateReport
    ) {
      if (nextProps.dateReport.length !== 0) {
        const { dateReport } = nextProps;
        ReportGeneration(dateReport, 'TransactionHistoryByDateReport');
        this.setState({ inProgress: false });
        this.props.clearReportDataAction();
      }
    }
  }

  formSubmit = values => {
    const model = {
      SiteId: values[ReportFieldEnum.Site],
      ItemId: values[ReportFieldEnum.Item],
      DtFrom: values[ReportFieldEnum.FromDate],
      DtTo: values[ReportFieldEnum.ToDate],
      AllDates: values[ReportFieldEnum.Balance],
      ReportFormat: this.state.reportFormat,
    };

    if (this.state.reportFormat === reportFormatEnum.PDF) {
      this.props.getHistoryByItemReportAction(model);
    } else {
      this.props.getHistoryByItemReportExcel(model);
    }
  };

  studentSubmit = values => {
    const model = {
      IdSeed: values[FieldEnum.IdSeed],
      FromDate: values[FieldEnum.FromDate],
      ToDate: values[FieldEnum.ToDate],
      SortBy: values[FieldEnum.SortBy],
      ReportFormat: this.state.reportFormat,
    };

    if (this.state.reportFormat === reportFormatEnum.PDF) {
      this.props.getHistoryByStudentReportAction(model);
    } else {
      this.props.getHistoryByStudentReportExcel(model);
    }
  };

  dateSubmit = values => {
    if (
      values[ReportFieldEnum.All] ||
      values[ReportFieldEnum.Breakfast] ||
      values[ReportFieldEnum.Lunch] ||
      values[ReportFieldEnum.Supper] ||
      values[ReportFieldEnum.Other] ||
      values[ReportFieldEnum.ManualAdjustments] ||
      values[ReportFieldEnum.ZeroBalanceAdjustment]
    ) {
      this.setState({ inProgress: true });
      const model = {
        SiteId: values[ReportFieldEnum.Site],
        UserId: values[ReportFieldEnum.User],
        FromDate: values[ReportFieldEnum.FromDate],
        ToDate: values[ReportFieldEnum.ToDate],
        IsAllTypes: values[ReportFieldEnum.All],
        IsBreakFast: values[ReportFieldEnum.Breakfast],
        IsLunch: values[ReportFieldEnum.Lunch],
        IsSupper: values[ReportFieldEnum.Supper],
        IsOthers: values[ReportFieldEnum.Other],
        IsManualAdjustment: values[ReportFieldEnum.ManualAdjustments],
        IsZeroBalance: values[ReportFieldEnum.ZeroBalanceAdjustment],
        AdditionFilter: values[ReportFieldEnum.AdditionalFilters],
        SortBy: values[ReportFieldEnum.SortBy],
        ReportFormat: this.state.reportFormat,
      };

      if (this.state.reportFormat === reportFormatEnum.PDF) {
        this.props.getHistoryByDateReportAction(model);
      } else {
        this.props.getHistoryByDateReportExcel(model);
      }
    } else {
      createToast(
        toastType.error,
        'Error',
        'Please Select at least one Type.',
        true
      );
    }
  };

  handleChange = (e, { value }) => {
    this.setState({ transactionType: value });
  };

  getStudentsData = obj => {
    this.props.getAccountSetup(obj);
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        formName: FormNameByTransactionType[this.state.transactionType],
        saveButtonProps: {
          content: 'View',
          loading: this.props.recordFetching,
          disabled: this.props.recordFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { transactionType, reportFormat } = this.state;

    return (
      <Fragment>
        <Filter title={'Transaction History'} />
        <Main {...this.getMainProps()}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label className="text-orange">Transaction Type</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button.Group
                  basic
                  className={
                    'btn-group--active-group transaction-history--btn-group'
                  }
                >
                  {Object.keys(TransactionType).map(type => (
                    <Button
                      key={type}
                      basic
                      className="white"
                      active={transactionType === TransactionType[type]}
                      onClick={() =>
                        this.setState({
                          transactionType: TransactionType[type],
                        })
                      }
                    >
                      By {type}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div className="field">
                  <label className="text-orange">Report Format</label>
                </div>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Button.Group
                  basic
                  className={
                    'btn-group--active-group transaction-history--btn-group'
                  }
                >
                  {Object.keys(reportFormatEnum).map(type => (
                    <Button
                      key={type}
                      basic
                      className="white"
                      active={reportFormat === reportFormatEnum[type]}
                      onClick={() =>
                        this.setState({
                          reportFormat: reportFormatEnum[type],
                        })
                      }
                    >
                      {type}
                    </Button>
                  ))}
                </Button.Group>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          {transactionType === TransactionType.Item && (
            <TransactionHistoryForm
              onSubmit={this.formSubmit}
              servedItems={this.props.servedItems}
              initialValues={{
                [ReportFieldEnum.FromDate]: moment().format('MM/DD/YYYY'),
                [ReportFieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
              }}
            />
          )}
          {transactionType === TransactionType.Student && (
            <TransactionHistoryByStudentForm
              onSubmit={this.studentSubmit}
              siteChange={this.siteChange}
              initialValues={{
                [ReportFieldEnum.FromDate]: moment().format('MM/DD/YYYY'),
                [ReportFieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
                [ReportFieldEnum.SortBy]: '1',
              }}
              getStudentsData={this.getStudentsData}
              data={this.props.studentData}
              gridLoading={this.props.gridLoading}
            />
          )}
          {transactionType === TransactionType.Date && (
            <TransactionHistoryByDateForm
              onSubmit={this.dateSubmit}
              siteChange={this.siteChange}
              userLoad={this.props.userLoad}
              usersData={this.props.usersData}
              initialValues={{
                [ReportFieldEnum.AdditionalFilters]: '0',
                [ReportFieldEnum.SortBy]: '1',
                [ReportFieldEnum.FromDate]: moment().format('MM/DD/YYYY'),
                [ReportFieldEnum.ToDate]: moment().format('MM/DD/YYYY'),
                [ReportFieldEnum.ReportFormat]: ReportFieldEnum.PDF,
              }}
              {...this.props}
            />
          )}
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  AccountSetupState,
  CommonState,
  SiteSetupState,
  TransactionHistoryState,
  TeacherRollsState,
}) => {
  return {
    studentData: AccountSetupState.studentData,
    sitesInfo: CommonState.sites.info,
    servedItems: SiteSetupState.servedItems.data,
    recordFetching: TransactionHistoryState.reportLoading,
    report: TransactionHistoryState.reports,
    teachersInfo: TeacherRollsState.teachersInfo,
    gridLoading: AccountSetupState.gridLoading,
    studentReport: TransactionHistoryState.studentReport,
    dateReport: TransactionHistoryState.dateReport,
    usersData: TransactionHistoryState.usersData,
    userLoad: TransactionHistoryState.userLoad,
  };
};

export const TransactionHistory = withRouter(
  connect(
    mapStateToProps,
    {
      getServedItems,
      getHistoryByItemReportAction,
      getHistoryByItemReportExcel,
      getHistoryByStudentReportAction,
      getHistoryByStudentReportExcel,
      getHistoryByDateReportAction,
      getHistoryByDateReportExcel,
      clearReportDataAction,
      getTeachersAction,
      getAccountSetup,
      getUsersAction,
    }
  )(TransactionHistoryContainer)
);



// WEBPACK FOOTER //
// ./src/pages/transactionhistory/TransactionHistory.js